<!--&================== TITLE TASK ==================&-->
<div class="title-components">
  <h1>Tarea asignada {{libraryName}}</h1>
</div>

<!--&================= CONTENT-TASKS =================&-->

<div class="Content-Task-Alone">
  <div class="Body-Card-Task">
    <div class="Body-Card-Alone">
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Nombre de Tarea
        </div>
        <div class="Text-Information">
          {{Task_FIN.Name}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Fecha de asignación
        </div>
        <div class="Text-Information">
          {{GetDate_Assigned(Task_FIN.Date_Start)}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Asignada por
        </div>
        <div class="Text-Information">
          {{Task_FIN.NameUser}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Descripción
        </div>
        <div class="Description-Noty" *ngIf="Task_FIN">
          <p>
            <ng-container *ngIf="Task_FIN.Real_ID_UR === 5; else normalTaskDesc">
              {{Task_FIN.Comment || 'Se le ha asignado una tarea de corrección para el documento: ' + Task_FIN.Name}}
            </ng-container>
            <ng-template #normalTaskDesc>
              Se le ha asignado la tarea de revisión del documento: {{Task_FIN.Name}}
            </ng-template>
          </p>
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Ubicación en librería
        </div>
        <button (click)="SeeFINLibrary()" class="Text-Information Btn-Ubication btn-icon-text-left">
          <span class="text">Ubicación proceso</span><i class="fa-solid fa-location-arrow"></i>
        </button>
      </div>
      <div class="Content-Grid-Task2">

        <div class="Text-Task">
          Descargar
        </div>

        <div class="Container-Button">

          <button (click)="PreviewFile($event)" class="Btn-Download-Global" style="background: #20a8e1; color: white; display: flex; align-items: center; justify-content: center; border: none; border-radius: var(--border-buton-r0);">
            <div class="Content-Download">
              <span class="Btn-Text">Vista Previa</span>
              <i class="fa-regular fa-eye" style="margin-left: 5px;"></i>
            </div>
          </button>

          <button (click)="DownloadFile()" class="Text-Information Btn-Download-Local Btn-Download-Global"
            id="Btn-Download">
            <div class="Content-Download">
              <span class="Progress-Bar-Task" id="Progress-Bar-Task"></span>
              <span class="Btn-Text" id="Text-Btn">Descargar documento</span>
              <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn"></i>
            </div>
          </button>

          <button (click)="Modal_See_Annexe(true)" class="Btn-Download-Global Btn-Annexe">
            <div class="Content-Download">
              <span class="Btn-Text" id="Text-Btn">Anexos</span>
              <i class="fa-regular fa-paste"></i>
            </div>
          </button>

        </div>
      </div>
    </div>

    <!---================= CONTENT-BTNS =================--->
    <div class="Bottom-Card-Alone" *ngIf="Task_FIN?.Real_ID_UR !== 5">
      <div class="Container-Btn-Alone">
        <div class="Btn-Approved">
          <button (click)="ApproveFIN()" class="btn-icon-text-left">
            <span class="text">Aprobar</span><i class="fa-solid fa-check-double"></i>
          </button>
        </div>
        <div class="Btn-Reject">
          <div (click)="ToggleModalReasonReject(true)" class="btn-icon-text-left">
            <span class="text">Rechazar</span><i class="fa-solid fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje para el Autor -->
    <div class="Bottom-Card-Alone" *ngIf="Task_FIN?.Real_ID_UR === 5">
      <div class="Container-Btn-Alone" style="justify-content: center;">
        <p style="color: #666; font-size: 14px; text-align: center;">
          <i>Para corregir este documento, haz clic en "Ubicación proceso" y sube una nueva versión.</i>
        </p>
      </div>
    </div>
  </div>
</div>



<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR SEE ANNEXES =====================--->
<section class="Modal-Global" id="Modal-See-Annexe">
  <div class="wrapper">
    <div class="Pro-popup-See-Annexes1 popup">
      <div class="Pro-inside-See-Annexes1 popup-inside">
        <div class="Pro-backgrounds-See-Annexes1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-content-See-Annexes1 content">
        <button (click)="Modal_See_Annexe(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Anexos</h2>
          <h4>Anexos de {{Task_FIN.Name}}</h4>
        </div>

        <div class="Content-body">

          <div class="Container-Annexes Container-Annexes-See">
            <div class="Container-Card-Annexes">

              <ng-container *ngIf="Task_FIN.Annexes.length>0;else Not_Annexes">

                <div *ngFor="let Annexe of Task_FIN.Annexes" class="Card-Annexes">

                  <div class="Container-File">
                    <ng-container *ngFor="let icon of Icons_Image">
                      <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                        <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                      </div>
                    </ng-container>
                    <div class="Name-Annexe">
                      {{CutNameFile(Annexe.Name,35)}}
                    </div>
                  </div>

                  <div class="Container-Buttons-Annexe">

                    <button (click)="Get_Download_Annexe(Annexe)" type="button" class="button-square">
                      <i class="fa-solid fa-download"></i>
                    </button>
                  </div>

                </div>
              </ng-container>

              <ng-template #Not_Annexes>

                <div class="Not-Annexes-See">
                  <div class="Img-Not-See">
                    <img src="./assets/Global/Ilustrations/Not-Annexes.png" alt="">
                  </div>
                  <div class="Text-See">
                    No hay anexos cargados en este proceso.
                  </div>
                </div>

              </ng-template>


            </div>
          </div>

          <div class="Container-Download-Annexe" id="Container-Download-Annexe">
            <div class="Container-progress-bar-Annexe">
              <span class="Progress-Bar-Annexe" id="Progress-Bar-Annexe"></span>
            </div>
          </div>

        </div>
        <div class="Content-Bottom Bottom-Modal-See-Annexe">
          <button (click)="Modal_See_Annexe(false)" class="Btn-Close-Modal ">
            <span>Cerrar</span>
          </button>

        </div>
      </div>

    </div>
  </div>
</section>


<!---===================== MODAL FOR REASON FOR REJECTION =====================--->
<section class="Modal-Global" id="ModalReject">
  <div class="wrapper">
    <div class="Pro-popup1 popup">
      <div class="Pro-inside1 popup-inside">
        <div class="Pro-backgrounds1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormReject" (ngSubmit)="SaveReject()">
        <div class="Pro-content1 content">
          <div (click)="ToggleModalReasonReject(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Rechazar proceso</h2>
            <h4>Escribe la razón de rechazo del proceso</h4>
          </div>

          <div class="Content-body">
            <div class="Content-grid-1">
              <div class="Container-input Text-Area-Form">
                <i class="fa-solid fa-signature"></i><textarea id="IdTextAreaRejectFIN" formControlName="ReasonText"
                  placeholder="Razón de rechazo ..."></textarea>
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form1 btn-icon-text">
              <i class="fa-solid fa-location-arrow"></i><span class="text">Enviar</span>
            </button>
            <div (click)="ToggleModalReasonReject(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<app-document-viewer [visible]="showPreview" [fileName]="previewFileName" [fileUrl]="previewFileUrl"
  [extension]="previewFileExtension" (onClose)="showPreview = false" (onDownload)="DownloadFromPreview()">
</app-document-viewer>
